// src/hooks/useInView.js

import {
  useEffect,
  useRef,
  useState
} from 'react';

export default function useInView({
  threshold = 0.2,
  rootMargin = '0px 0px -10% 0px',
  once = true
} = {}) {
  const elementRef = useRef(null);

  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  useEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return undefined;
    }

    if (
      typeof window === 'undefined' ||
      !('IntersectionObserver' in window)
    ) {
      setIsVisible(true);

      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);

          if (once) {
            observer.unobserve(entry.target);
          }
        } else if (!once) {
          setIsVisible(false);
        }
      },
      {
        threshold,
        rootMargin
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [
    threshold,
    rootMargin,
    once
  ]);

  return {
    ref: elementRef,
    isVisible
  };
}